import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "list-page-panel is-header-minimal"
};
const _hoisted_2 = {
  class: "list-page-heading"
};
const _hoisted_3 = {
  class: "list-page-heading-actions"
};
const _hoisted_4 = ["disabled"];
const _hoisted_5 = ["disabled"];
const _hoisted_6 = {
  class: "grid grid-cols-1 gap-4 lg:grid-cols-[280px_minmax(0,1fr)] 2xl:grid-cols-[320px_minmax(0,1fr)]"
};
const _hoisted_7 = {
  class: "min-h-[520px] min-w-0 overflow-hidden rounded-lg border border-slate-200 bg-white lg:min-h-[640px]"
};
const _hoisted_8 = {
  key: 0,
  class: "flex h-full min-h-[420px] items-center justify-center p-6 sm:p-10 lg:min-h-[640px]"
};
const _hoisted_9 = {
  class: "text-center"
};
const _hoisted_10 = {
  class: "mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-slate-100 text-slate-400"
};
const _hoisted_11 = {
  key: 1,
  class: "flex h-full min-h-[520px] flex-col lg:min-h-[640px]"
};
const _hoisted_12 = {
  class: "border-b border-slate-200 px-4 py-4 sm:px-5"
};
const _hoisted_13 = {
  class: "flex items-start justify-between gap-3"
};
const _hoisted_14 = {
  class: "min-w-0 flex-1"
};
const _hoisted_15 = {
  class: "flex flex-wrap items-center gap-2"
};
const _hoisted_16 = {
  class: "truncate text-lg font-semibold text-slate-900"
};
const _hoisted_17 = {
  class: "mt-1 text-sm text-slate-500"
};
const _hoisted_18 = {
  class: "flex shrink-0 flex-wrap gap-2 sm:justify-end"
};
const _hoisted_19 = ["disabled"];
const _hoisted_20 = ["disabled"];
const _hoisted_21 = {
  class: "overflow-x-auto px-4 sm:px-5 border-b border-slate-200"
};
const _hoisted_22 = {
  class: "flex min-w-max gap-2",
  "aria-label": "企营增开票视图"
};
const _hoisted_23 = {
  class: "min-h-0 flex-1 overflow-y-auto p-3 sm:p-5"
};
const _hoisted_24 = {
  key: 0,
  class: "flex h-80 items-center justify-center text-sm text-slate-500"
};
const _hoisted_25 = {
  class: "space-y-4"
};
const _hoisted_26 = {
  class: "space-y-4"
};
const _hoisted_27 = {
  class: "space-y-4"
};
import { computed, reactive, ref, watch } from 'vue';
import { ElMessageBox, ElMessage } from 'element-plus';
import { ArrowPathIcon, CheckCircleIcon } from '@heroicons/vue/24/outline';
import ListPageShell from '@/components/ListPageShell.vue';
import { confirmEnterpriseInvoiceList, confirmEnterpriseInvoicePlan, createEnterpriseInvoiceCustomer, createEnterpriseInvoiceCustomerWithMonth, createEnterpriseInvoiceRegion, deleteEnterpriseInvoiceCustomer, deleteEnterpriseInvoicePlanCustomer, deleteEnterpriseInvoiceRegion, exportEnterpriseInvoiceChains, generateEnterpriseInvoiceChains, generateEnterpriseInvoiceForUnfilledCustomers, getEnterpriseInvoiceCompanyChainRelations, getEnterpriseInvoiceCustomerTagOptions, getEnterpriseInvoiceCustomerTags, getEnterpriseInvoiceCustomerWorkbench, lockEnterpriseInvoiceChain, lockEnterpriseInvoiceChainNode, moveEnterpriseInvoiceCustomers, replaceEnterpriseInvoiceCustomerTags, replaceEnterpriseInvoiceDownstreamAllocations, replaceEnterpriseInvoiceDownstreamTagPreferences, regenerateEnterpriseInvoiceAfterNode, regenerateEnterpriseInvoiceChain, regenerateEnterpriseInvoiceUnlockedChains, reorderEnterpriseInvoiceRegions, sortEnterpriseInvoiceRegionsByAmount, unlockEnterpriseInvoiceChain, updateEnterpriseInvoiceCustomer, updateEnterpriseInvoiceChainNode, updateEnterpriseInvoiceRegion } from '@/api/invoice';
import { useEnterpriseInvoicePlanState } from './composables/useEnterpriseInvoicePlanState';
import { canGenerateChains, statusLabel, statusTone } from './utils';
import InvoicePlanPanel from './components/InvoicePlanPanel.vue';
import InvoicePlanModal from './components/InvoicePlanModal.vue';
import InvoiceCustomerModal from './components/InvoiceCustomerModal.vue';
import InvoiceCustomerMasterModal from './components/InvoiceCustomerMasterModal.vue';
import InvoiceRegionModal from './components/InvoiceRegionModal.vue';
import InvoiceMonthlyCustomerWorkbench from './components/InvoiceMonthlyCustomerWorkbench.vue';
import InvoiceRegionListEditor from './components/InvoiceRegionListEditor.vue';
import InvoiceChainWorkspace from './components/InvoiceChainWorkspace.vue';
import InvoiceNodeEditPanel from './components/InvoiceNodeEditPanel.vue';
import InvoiceDownstreamAllocationDialog from './components/InvoiceDownstreamAllocationDialog.vue';
import InvoiceDownstreamTagPreferenceDialog from './components/InvoiceDownstreamTagPreferenceDialog.vue';
const tabBaseClass = 'border-b-2 px-4 py-3 text-sm font-medium transition-colors';
const tabActiveClass = 'border-primary-500 text-primary-600';
const tabInactiveClass = 'border-transparent text-slate-500 hover:border-slate-300 hover:text-slate-700';
export default {
  __name: 'InvoicePlanManagement',
  setup(__props, {
    expose: __expose
  }) {
    const selectedPlanId = ref(null);
    const activeTab = ref('monthly-customers');
    const planPanelRef = ref(null);
    const state = useEnterpriseInvoicePlanState();
    const customerWorkbenchRows = ref([]);
    const customerWorkbenchLoading = ref(false);
    const customerWorkbenchKeyword = ref('');
    const customerWorkbenchJoinedFilter = ref('all');
    const customerWorkbenchPlannerUserId = ref(null);
    const customerWorkbenchFinanceUserId = ref(null);
    const customerWorkbenchChannelSource = ref('');
    const customerWorkbenchPage = ref(1);
    const customerWorkbenchSize = ref(20);
    const customerWorkbenchTotal = ref(0);
    const customerTags = ref([]);
    const exportingChains = ref(false);
    const companyRelationKeyword = ref('');
    const companyRelationResult = ref(null);
    const companyRelationLoading = ref(false);
    const companyRelationFocusChainId = ref(null);
    const planModal = reactive({
      visible: false,
      mode: 'create',
      basePlan: null
    });
    const customerModal = reactive({
      visible: false,
      customer: null
    });
    const masterCustomerModal = reactive({
      visible: false,
      mode: 'create',
      customer: null,
      tagIds: [],
      tagsLoading: false,
      saving: false
    });
    const regionModal = reactive({
      visible: false,
      region: null
    });
    const nodePanel = reactive({
      visible: false,
      context: null
    });
    const downstreamAllocationDialog = reactive({
      visible: false,
      customer: null
    });
    const downstreamTagPreferenceDialog = reactive({
      visible: false,
      customer: null
    });
    const badgeClassByTone = {
      neutral: 'status-badge is-neutral',
      primary: 'status-badge is-info',
      amber: 'status-badge is-warning',
      emerald: 'status-badge is-success',
      red: 'status-badge is-danger'
    };
    const canOperate = computed(() => Boolean(selectedPlanId.value));
    function handleSyncResult(sync) {
      state.applySyncResult(sync);
    }
    async function handleCustomerModalSaved(sync, payload) {
      await handleMonthCustomerSaved(sync, payload);
    }
    watch(selectedPlanId, async planId => {
      clearCompanyChainRelations();
      if (!planId) {
        customerWorkbenchRows.value = [];
        customerWorkbenchTotal.value = 0;
        customerWorkbenchPage.value = 1;
        return;
      }
      customerWorkbenchPage.value = 1;
      await state.loadPlan(planId);
      await loadCustomerTagOptions();
      await loadCustomerWorkbench();
    }, {
      immediate: false
    });
    async function loadCustomerTagOptions() {
      try {
        const tags = await getEnterpriseInvoiceCustomerTagOptions();
        customerTags.value = Array.isArray(tags) ? tags : [];
      } catch (error) {
        console.error('Failed to load enterprise invoice customer tag options', error);
        customerTags.value = [];
      }
    }
    function customerWorkbenchParams() {
      const params = {
        page: customerWorkbenchPage.value,
        size: customerWorkbenchSize.value
      };
      const keyword = customerWorkbenchKeyword.value.trim();
      if (keyword) {
        params.keyword = keyword;
      }
      if (customerWorkbenchJoinedFilter.value === 'joined') {
        params.joinedCurrentMonth = true;
      }
      if (customerWorkbenchJoinedFilter.value === 'notJoined') {
        params.joinedCurrentMonth = false;
      }
      if (customerWorkbenchPlannerUserId.value) {
        params.plannerUserId = customerWorkbenchPlannerUserId.value;
      }
      if (customerWorkbenchFinanceUserId.value) {
        params.financeUserId = customerWorkbenchFinanceUserId.value;
      }
      const channelSource = customerWorkbenchChannelSource.value.trim();
      if (channelSource) {
        params.channelSource = channelSource;
      }
      return params;
    }
    async function loadCustomerWorkbench() {
      if (!selectedPlanId.value) {
        customerWorkbenchRows.value = [];
        customerWorkbenchTotal.value = 0;
        return;
      }
      customerWorkbenchLoading.value = true;
      try {
        const page = await getEnterpriseInvoiceCustomerWorkbench(selectedPlanId.value, customerWorkbenchParams());
        customerWorkbenchRows.value = page.records || [];
        customerWorkbenchTotal.value = Number(page.total || 0);
        customerWorkbenchPage.value = Number(page.current || customerWorkbenchPage.value);
        customerWorkbenchSize.value = Number(page.size || customerWorkbenchSize.value);
      } catch (error) {
        console.error('Failed to load enterprise invoice customer workbench', error);
        ElMessage.error(error.message || '加载月度客户失败');
      } finally {
        customerWorkbenchLoading.value = false;
      }
    }
    async function searchCustomerWorkbench() {
      customerWorkbenchPage.value = 1;
      await loadCustomerWorkbench();
    }
    async function changeCustomerWorkbenchPage(page) {
      customerWorkbenchPage.value = page;
      await loadCustomerWorkbench();
    }
    async function changeCustomerWorkbenchSize(size) {
      customerWorkbenchSize.value = size;
      customerWorkbenchPage.value = 1;
      await loadCustomerWorkbench();
    }
    async function handleMonthCustomerSaved(sync, payload) {
      if (!sync) return;
      handleSyncResult(sync);
      const pendingTarget = payload?.regionBucketId;
      const modalCustomerId = customerModal.customer?.customerId;
      if (pendingTarget && modalCustomerId) {
        const matched = (sync.customers || []).find(customer => String(customer.customerId) === String(modalCustomerId));
        if (matched && String(matched.regionBucketId) !== String(pendingTarget)) {
          const moved = await state.runSyncAction(() => moveEnterpriseInvoiceCustomers(selectedPlanId.value, pendingTarget, {
            planCustomerIds: [matched.id],
            targetRegionId: pendingTarget
          }), '客户已添加到目标区域');
          if (!moved) {
            ElMessage.warning('客户已加入本月，但移动到目标区域失败，可在名单中重新移动');
          }
        }
      }
      await loadCustomerWorkbench();
    }
    function statusClass(status) {
      const tone = statusTone(status);
      return badgeClassByTone[tone] || badgeClassByTone.neutral;
    }
    function tabClass(tab) {
      return [tabBaseClass, activeTab.value === tab ? tabActiveClass : tabInactiveClass];
    }
    function ensurePlanSelected() {
      return canOperate.value;
    }
    function openCreatePlan() {
      planModal.mode = 'create';
      planModal.basePlan = null;
      planModal.visible = true;
    }
    function openCopyPlan(plan) {
      planModal.mode = 'copy';
      planModal.basePlan = plan;
      planModal.visible = true;
    }
    async function afterPlanSaved(plan) {
      await planPanelRef.value?.loadPlans?.();
      selectedPlanId.value = plan?.id || selectedPlanId.value;
    }
    async function reloadCurrentPlan() {
      if (!selectedPlanId.value) return;
      await state.loadPlan(selectedPlanId.value);
      await loadCustomerTagOptions();
      await loadCustomerWorkbench();
    }
    function openJoinMonth(row) {
      customerModal.customer = {
        customerId: row.customerId,
        companyName: row.companyName,
        registeredRegion: row.registeredRegion,
        targetOutputAmount: null,
        targetProfitRate: null,
        regionBucketId: null,
        inputProductQuotas: row.inputProductQuotas,
        outputProductQuotas: row.outputProductQuotas,
        inputProductNames: row.inputProductNames,
        outputProductNames: row.outputProductNames
      };
      customerModal.visible = true;
    }
    function openEditMonth(row) {
      customerModal.customer = {
        id: row.planCustomerId,
        customerId: row.customerId,
        companyName: row.companyNameSnapshot || row.companyName,
        registeredRegion: row.registeredRegionSnapshot || row.registeredRegion,
        regionBucketId: row.regionBucketId,
        targetOutputAmount: row.targetOutputAmount,
        targetProfitRate: row.targetProfitRate,
        inputProductQuotas: row.inputProductQuotas,
        outputProductQuotas: row.outputProductQuotas,
        inputProductNames: row.inputProductNames,
        outputProductNames: row.outputProductNames,
        displayOrder: row.displayOrder
      };
      customerModal.visible = true;
    }
    function openCreateMonthFromRegion(payload) {
      const region = payload?.region || null;
      customerModal.customer = {
        customerId: null,
        companyName: '',
        registeredRegion: region?.regionName || '',
        targetOutputAmount: null,
        targetProfitRate: null,
        regionBucketId: region?.id || null
      };
      customerModal.visible = true;
    }
    function openEditMonthFromPlanCustomer(customer) {
      if (!customer?.id) return;
      customerModal.customer = {
        id: customer.id,
        customerId: customer.customerId,
        companyName: customer.companyNameSnapshot || customer.companyName || customer.customerName || customer.name,
        registeredRegion: customer.registeredRegionSnapshot || customer.registeredRegion,
        regionBucketId: customer.regionBucketId,
        targetOutputAmount: customer.targetOutputAmount,
        targetProfitRate: customer.targetProfitRate,
        inputProductQuotas: customer.inputProductQuotas,
        outputProductQuotas: customer.outputProductQuotas,
        inputProductNames: customer.inputProductNames,
        outputProductNames: customer.outputProductNames,
        displayOrder: customer.displayOrder
      };
      customerModal.visible = true;
    }
    async function removeFromMonth(row) {
      if (!ensurePlanSelected() || !row?.planCustomerId) return;
      try {
        await ElMessageBox.confirm('确认将该客户从本月移除？客户主档会保留。', '移除本月客户', {
          confirmButtonText: '移除',
          cancelButtonText: '取消',
          type: 'warning'
        });
      } catch {
        return;
      }
      const sync = await state.runSyncAction(() => deleteEnterpriseInvoicePlanCustomer(selectedPlanId.value, row.planCustomerId), '已从本月移除');
      if (sync) await loadCustomerWorkbench();
    }
    function openCreateMasterCustomer() {
      masterCustomerModal.mode = 'create';
      masterCustomerModal.customer = null;
      masterCustomerModal.tagIds = [];
      masterCustomerModal.visible = true;
      loadCustomerTagOptions();
    }
    async function openEditMasterCustomer(row) {
      if (!row?.customerId) return;
      masterCustomerModal.mode = 'edit';
      masterCustomerModal.customer = row;
      masterCustomerModal.tagIds = [];
      masterCustomerModal.visible = true;
      await Promise.all([loadCustomerTagOptions(), loadCustomerTagsForModal(row.customerId)]);
    }
    async function saveMasterCustomer(payload) {
      if (!payload?.customer) return;
      if (masterCustomerModal.saving) return;
      masterCustomerModal.saving = true;
      try {
        if (masterCustomerModal.mode === 'edit') {
          const updated = await updateEnterpriseInvoiceCustomer(masterCustomerModal.customer.customerId, payload.customer);
          await saveCustomerTags(updated?.id || masterCustomerModal.customer.customerId, payload.tagIds);
          ElMessage.success('客户已更新');
          masterCustomerModal.visible = false;
          await loadCustomerWorkbench();
          return;
        }
        if (payload.joinMonth) {
          if (!selectedPlanId.value) {
            ElMessage.warning('请选择月度方案');
            return;
          }
          const sync = await createEnterpriseInvoiceCustomerWithMonth(selectedPlanId.value, payload);
          handleSyncResult(sync);
          ElMessage.success('客户已创建并加入本月');
          masterCustomerModal.visible = false;
          await loadCustomerWorkbench();
          return;
        }
        const created = await createEnterpriseInvoiceCustomer(payload.customer);
        await saveCustomerTags(created.id, payload.tagIds);
        ElMessage.success('客户已创建');
        masterCustomerModal.visible = false;
        await loadCustomerWorkbench();
      } catch (error) {
        console.error('Failed to save enterprise invoice customer master', error);
        ElMessage.error(error.message || '保存客户失败');
      } finally {
        masterCustomerModal.saving = false;
      }
    }
    async function loadCustomerTagsForModal(customerId) {
      masterCustomerModal.tagsLoading = true;
      try {
        const tags = await getEnterpriseInvoiceCustomerTags(customerId);
        masterCustomerModal.tagIds = (Array.isArray(tags) ? tags : []).map(tag => tag.id);
      } catch (error) {
        console.error('Failed to load enterprise invoice customer tags', error);
        masterCustomerModal.tagIds = [];
        ElMessage.warning('客户标签加载失败');
      } finally {
        masterCustomerModal.tagsLoading = false;
      }
    }
    async function saveCustomerTags(customerId, tagIds = []) {
      if (!customerId) return;
      try {
        await replaceEnterpriseInvoiceCustomerTags(customerId, {
          tagIds: tagIds || []
        });
      } catch (error) {
        console.error('Failed to save enterprise invoice customer tags', error);
        ElMessage.warning('客户信息已保存，但标签保存失败，可重新编辑标签');
      }
    }
    async function openDownstreamAllocation(customer) {
      if (!customer?.id) return;
      await loadCustomerTagOptions();
      downstreamAllocationDialog.customer = customer;
      downstreamAllocationDialog.visible = true;
    }
    async function openDownstreamTagPreference(customer) {
      if (!customer?.id) return;
      await loadCustomerTagOptions();
      downstreamTagPreferenceDialog.customer = customer;
      downstreamTagPreferenceDialog.visible = true;
    }
    async function saveDownstreamAllocations(payload) {
      if (!ensurePlanSelected() || !payload?.customer?.id) return;
      const sync = await state.runSyncAction(() => replaceEnterpriseInvoiceDownstreamAllocations(selectedPlanId.value, payload.customer.id, {
        allocations: payload.allocations || []
      }), '指定下游已保存');
      if (sync) {
        downstreamAllocationDialog.visible = false;
        await loadCustomerWorkbench();
      }
    }
    async function saveDownstreamTagPreferences(payload) {
      if (!ensurePlanSelected() || !payload?.customer?.id) return;
      const sync = await state.runSyncAction(() => replaceEnterpriseInvoiceDownstreamTagPreferences(selectedPlanId.value, payload.customer.id, {
        preferences: payload.preferences || []
      }), '下游标签偏好已保存');
      if (sync) {
        downstreamTagPreferenceDialog.visible = false;
        await loadCustomerWorkbench();
      }
    }
    async function deleteMasterCustomer(row) {
      if (!row?.customerId) return;
      try {
        await ElMessageBox.confirm('确认删除该客户主档？存在任意月度开票记录时后端会拒绝删除。', '删除客户', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        });
        await deleteEnterpriseInvoiceCustomer(row.customerId);
        ElMessage.success('客户已删除');
        await loadCustomerWorkbench();
      } catch (error) {
        if (error === 'cancel') return;
        console.error('Failed to delete enterprise invoice customer', error);
        ElMessage.error(error.message || '删除客户失败');
      }
    }
    function openCreateRegion() {
      regionModal.region = null;
      regionModal.visible = true;
    }
    function openRenameRegion(region) {
      regionModal.region = region;
      regionModal.visible = true;
    }
    async function saveRegionModal(payload) {
      if (!ensurePlanSelected()) return;
      const action = payload.id ? () => updateEnterpriseInvoiceRegion(selectedPlanId.value, payload.id, {
        regionName: payload.regionName
      }) : () => createEnterpriseInvoiceRegion(selectedPlanId.value, {
        regionName: payload.regionName
      });
      const sync = await state.runSyncAction(action, payload.id ? '区域已重命名' : '区域已创建');
      if (sync) {
        regionModal.visible = false;
        await loadCustomerWorkbench();
      }
    }
    async function deleteRegion(region) {
      if (!ensurePlanSelected() || !region?.id) return;
      const regionName = region.regionName || '未命名区域';
      try {
        await ElMessageBox.confirm(`确定删除区域“${regionName}”吗？删除后不可恢复。`, '删除区域', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        });
      } catch {
        return;
      }
      const sync = await state.runSyncAction(() => deleteEnterpriseInvoiceRegion(selectedPlanId.value, region.id), '区域已删除');
      if (sync) await loadCustomerWorkbench();
    }
    async function reorderRegions(regions) {
      if (!ensurePlanSelected()) return;
      const sync = await state.runSyncAction(() => reorderEnterpriseInvoiceRegions(selectedPlanId.value, {
        regionIds: regions.map(region => region.id)
      }), '区域顺序已保存');
      if (sync) await loadCustomerWorkbench();
    }
    async function sortRegionsByAmount() {
      if (!ensurePlanSelected()) return;
      const sync = await state.runSyncAction(() => sortEnterpriseInvoiceRegionsByAmount(selectedPlanId.value, true), '区域已按金额排序');
      if (sync) await loadCustomerWorkbench();
    }
    async function moveMatrixCustomer(payload) {
      if (!ensurePlanSelected() || !payload?.targetRegionId || !payload?.planCustomerId) return null;
      const planCustomerId = payload.planCustomerId;
      const sync = await state.runSyncAction(() => moveEnterpriseInvoiceCustomers(selectedPlanId.value, payload.targetRegionId, {
        planCustomerIds: [planCustomerId],
        targetRegionId: payload.targetRegionId,
        beforePlanCustomerId: payload.beforePlanCustomerId,
        afterPlanCustomerId: payload.afterPlanCustomerId
      }), '客户区域已更新');
      if (sync) payload.finishEdit?.();
      if (sync) await loadCustomerWorkbench();
      return sync;
    }
    async function deleteCustomer(customer) {
      if (!ensurePlanSelected() || !customer?.id) return;
      const customerName = customer.companyNameSnapshot || customer.companyName || customer.customerName || customer.name || '未命名客户';
      try {
        await ElMessageBox.confirm(`确定删除客户“${customerName}”吗？删除后不可恢复。`, '删除客户', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        });
      } catch {
        return;
      }
      const sync = await state.runSyncAction(() => deleteEnterpriseInvoicePlanCustomer(selectedPlanId.value, customer.id), '客户已从当月方案删除');
      if (sync) await loadCustomerWorkbench();
    }
    async function confirmList() {
      if (!ensurePlanSelected()) return;
      await state.runSyncAction(() => confirmEnterpriseInvoiceList(selectedPlanId.value), '名单已确认');
    }
    async function generateChains() {
      if (!ensurePlanSelected()) return;
      if (!canGenerateChains(state.plan.value)) return;
      const sync = await state.runSyncAction(() => generateEnterpriseInvoiceChains(selectedPlanId.value, {
        minChainSubjectCount: state.plan.value?.minChainSubjectCount || 10,
        maxChainSubjectCount: state.plan.value?.maxChainSubjectCount || 20,
        startAmountTiers: state.plan.value?.startAmountTiers
      }), '链路已生成');
      if (sync) {
        activeTab.value = 'chains';
      }
    }
    async function loadCompanyChainRelations(keyword) {
      if (!ensurePlanSelected() || companyRelationLoading.value) return;
      const companyName = String(keyword ?? companyRelationKeyword.value ?? '').trim();
      if (!companyName) {
        ElMessage.warning('请输入公司名称');
        return;
      }
      companyRelationKeyword.value = companyName;
      companyRelationLoading.value = true;
      companyRelationFocusChainId.value = null;
      try {
        companyRelationResult.value = await getEnterpriseInvoiceCompanyChainRelations(selectedPlanId.value, companyName);
      } catch (error) {
        console.error('Failed to load enterprise invoice company chain relations', error);
        ElMessage.error(error.message || '查询公司上下游失败');
      } finally {
        companyRelationLoading.value = false;
      }
    }
    function clearCompanyChainRelations() {
      companyRelationKeyword.value = '';
      companyRelationResult.value = null;
      companyRelationLoading.value = false;
      companyRelationFocusChainId.value = null;
    }
    function locateCompanyRelation(match) {
      const chainId = match?.chain?.id;
      if (!chainId) return;
      companyRelationFocusChainId.value = chainId;
      activeTab.value = 'chains';
    }
    function defaultExportFileName() {
      const month = String(state.plan.value?.planMonth || '').replace(/-/g, '');
      return `企营增${month || '开票链路'}.xlsx`;
    }
    function downloadBlob(blob, fileName) {
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName || '企营增开票链路.xlsx';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    }
    async function exportChains() {
      if (!ensurePlanSelected() || exportingChains.value) return;
      exportingChains.value = true;
      try {
        const blob = await exportEnterpriseInvoiceChains(selectedPlanId.value);
        downloadBlob(blob, defaultExportFileName());
        ElMessage.success('导出已开始');
      } catch (error) {
        console.error('Failed to export enterprise invoice chains', error);
        ElMessage.error(error.message || '导出链路失败');
      } finally {
        exportingChains.value = false;
      }
    }
    async function regenerateUnlocked() {
      if (!ensurePlanSelected()) return;
      await state.runSyncAction(() => regenerateEnterpriseInvoiceUnlockedChains(selectedPlanId.value), '未锁定链路已重排');
    }
    async function generateUnfilled() {
      if (!ensurePlanSelected()) return;
      await state.runSyncAction(() => generateEnterpriseInvoiceForUnfilledCustomers(selectedPlanId.value), '未完成客户已补齐');
    }
    function openEditNode(payload) {
      nodePanel.context = payload;
      nodePanel.visible = true;
    }
    async function lockChain({
      chain,
      locked
    }) {
      if (!ensurePlanSelected() || !chain?.id) return;
      const action = locked ? () => lockEnterpriseInvoiceChain(selectedPlanId.value, chain.id) : () => unlockEnterpriseInvoiceChain(selectedPlanId.value, chain.id);
      await state.runSyncAction(action, locked ? '链路已锁定' : '链路已解锁');
    }
    async function lockNode(payload) {
      if (!ensurePlanSelected() || !payload?.chain?.id || !payload?.node?.id) return;
      await state.runSyncAction(() => lockEnterpriseInvoiceChainNode(selectedPlanId.value, payload.chain.id, payload.node.id, payload.locks), '节点锁定状态已保存');
    }
    async function regenerateChain(chain) {
      if (!ensurePlanSelected() || !chain?.id) return;
      await state.runSyncAction(() => regenerateEnterpriseInvoiceChain(selectedPlanId.value, chain.id), '链路已重排');
    }
    async function regenerateAfterNode({
      chain,
      node
    }) {
      if (!ensurePlanSelected() || !chain?.id || !node?.id) return;
      await state.runSyncAction(() => regenerateEnterpriseInvoiceAfterNode(selectedPlanId.value, chain.id, node.id), '节点后链路已重排');
    }
    async function saveNodeEdit(payload) {
      if (!ensurePlanSelected() || !payload?.chain?.id || !payload?.node?.id) return;
      const nodePayload = payload.nodePayload || payload.data || null;
      let sync = null;
      if (nodePayload) {
        sync = await state.runSyncAction(() => updateEnterpriseInvoiceChainNode(selectedPlanId.value, payload.chain.id, payload.node.id, nodePayload), '节点已保存');
        if (!sync) return;
      }
      if (payload.locks) {
        sync = await state.runSyncAction(() => lockEnterpriseInvoiceChainNode(selectedPlanId.value, payload.chain.id, payload.node.id, payload.locks), '节点锁定状态已保存');
        if (!sync) return;
      }
      if (!nodePayload && !payload.locks) return;
      nodePanel.visible = false;
    }
    async function validatePlan() {
      if (!ensurePlanSelected()) return;
      await state.refreshIssues(selectedPlanId.value, '校验已完成');
    }
    async function confirmPlan() {
      if (!ensurePlanSelected()) return;
      if (state.hasErrorIssues.value) {
        ElMessage.warning('存在 ERROR 校验问题，请处理后再确认方案');
        return;
      }
      await state.runSyncAction(() => confirmEnterpriseInvoicePlan(selectedPlanId.value), '方案已确认');
    }
    __expose({
      validatePlan
    });
    return (_ctx, _cache) => {
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createBlock(ListPageShell, null, {
        header: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[19] || (_cache[19] = _createElementVNode("div", {
          class: "list-page-heading-main"
        }, [_createElementVNode("h1", {
          class: "text-xl font-semibold text-slate-900"
        }, "企营增开票"), _createElementVNode("p", {
          class: "mt-1 text-sm text-slate-500"
        }, "维护月度客户名单、区域排列、供应链链路和校验结果。")], -1)), _createElementVNode("div", _hoisted_3, [_createElementVNode("button", {
          type: "button",
          class: "btn-secondary inline-flex items-center gap-2",
          disabled: !selectedPlanId.value || _unref(state).loading.value,
          onClick: reloadCurrentPlan
        }, [_createVNode(_unref(ArrowPathIcon), {
          class: "h-4 w-4"
        }), _cache[17] || (_cache[17] = _createTextVNode(" 刷新 ", -1))], 8, _hoisted_4), _withDirectives((_openBlock(), _createElementBlock("button", {
          type: "button",
          class: "btn-primary inline-flex items-center gap-2",
          disabled: !selectedPlanId.value || _unref(state).syncing.value || _unref(state).hasErrorIssues.value,
          onClick: confirmPlan
        }, [_createVNode(_unref(CheckCircleIcon), {
          class: "h-4 w-4"
        }), _cache[18] || (_cache[18] = _createTextVNode(" 确认方案 ", -1))], 8, _hoisted_5)), [[_directive_permission, 'enterprise-invoice:plan:confirm']])])])])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createVNode(InvoicePlanPanel, {
          ref_key: "planPanelRef",
          ref: planPanelRef,
          modelValue: selectedPlanId.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => selectedPlanId.value = $event),
          onCreate: openCreatePlan,
          onCopy: openCopyPlan
        }, null, 8, ["modelValue"]), _createElementVNode("section", _hoisted_7, [!selectedPlanId.value ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createVNode(_unref(CheckCircleIcon), {
          class: "h-6 w-6"
        })]), _cache[20] || (_cache[20] = _createElementVNode("p", {
          class: "mt-3 text-sm font-medium text-slate-700"
        }, "请选择或新建一个月度方案", -1))])])) : (_openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("header", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createElementVNode("h2", _hoisted_16, _toDisplayString(_unref(state).plan.value?.planName || '月度方案'), 1), _createElementVNode("span", {
          class: _normalizeClass(['status-badge', statusClass(_unref(state).plan.value?.status)])
        }, _toDisplayString(_unref(statusLabel)(_unref(state).plan.value?.status)), 3)]), _createElementVNode("p", _hoisted_17, _toDisplayString(_unref(state).plan.value?.planMonth || '-') + " · 金额按 100 元取整 ", 1)]), _createElementVNode("div", _hoisted_18, [_withDirectives((_openBlock(), _createElementBlock("button", {
          type: "button",
          class: "btn-secondary whitespace-nowrap",
          disabled: _unref(state).syncing.value,
          onClick: confirmList
        }, [...(_cache[21] || (_cache[21] = [_createTextVNode("确认名单", -1)]))], 8, _hoisted_19)), [[_directive_permission, 'enterprise-invoice:list:confirm']]), _withDirectives((_openBlock(), _createElementBlock("button", {
          type: "button",
          class: "btn-primary whitespace-nowrap",
          disabled: _unref(state).syncing.value || !_unref(canGenerateChains)(_unref(state).plan.value),
          onClick: generateChains
        }, [...(_cache[22] || (_cache[22] = [_createTextVNode("生成链路", -1)]))], 8, _hoisted_20)), [[_directive_permission, 'enterprise-invoice:chain:generate']])])])]), _createElementVNode("div", _hoisted_21, [_createElementVNode("nav", _hoisted_22, [_createElementVNode("button", {
          type: "button",
          class: _normalizeClass(tabClass('monthly-customers')),
          onClick: _cache[1] || (_cache[1] = $event => activeTab.value = 'monthly-customers')
        }, " 月度客户 ", 2), _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(tabClass('list')),
          onClick: _cache[2] || (_cache[2] = $event => activeTab.value = 'list')
        }, " 名单 ", 2), _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(tabClass('chains')),
          onClick: _cache[3] || (_cache[3] = $event => activeTab.value = 'chains')
        }, " 链路 ", 2)])]), _createElementVNode("main", _hoisted_23, [_unref(state).loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_24, " 加载中... ")) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_withDirectives(_createElementVNode("section", _hoisted_25, [_createVNode(InvoiceMonthlyCustomerWorkbench, {
          keyword: customerWorkbenchKeyword.value,
          "onUpdate:keyword": _cache[4] || (_cache[4] = $event => customerWorkbenchKeyword.value = $event),
          "joined-filter": customerWorkbenchJoinedFilter.value,
          "onUpdate:joinedFilter": _cache[5] || (_cache[5] = $event => customerWorkbenchJoinedFilter.value = $event),
          "planner-user-id": customerWorkbenchPlannerUserId.value,
          "onUpdate:plannerUserId": _cache[6] || (_cache[6] = $event => customerWorkbenchPlannerUserId.value = $event),
          "finance-user-id": customerWorkbenchFinanceUserId.value,
          "onUpdate:financeUserId": _cache[7] || (_cache[7] = $event => customerWorkbenchFinanceUserId.value = $event),
          "channel-source": customerWorkbenchChannelSource.value,
          "onUpdate:channelSource": _cache[8] || (_cache[8] = $event => customerWorkbenchChannelSource.value = $event),
          rows: customerWorkbenchRows.value,
          loading: customerWorkbenchLoading.value,
          syncing: _unref(state).syncing.value,
          page: customerWorkbenchPage.value,
          size: customerWorkbenchSize.value,
          total: customerWorkbenchTotal.value,
          "customer-tags": customerTags.value,
          "downstream-allocations": _unref(state).downstreamAllocations.value,
          "downstream-tag-preferences": _unref(state).downstreamTagPreferences.value,
          onSearch: searchCustomerWorkbench,
          onPageChange: changeCustomerWorkbenchPage,
          onSizeChange: changeCustomerWorkbenchSize,
          onCreateMaster: openCreateMasterCustomer,
          onEditMaster: openEditMasterCustomer,
          onDeleteMaster: deleteMasterCustomer,
          onJoinMonth: openJoinMonth,
          onEditMonth: openEditMonth,
          onRemoveMonth: removeFromMonth
        }, null, 8, ["keyword", "joined-filter", "planner-user-id", "finance-user-id", "channel-source", "rows", "loading", "syncing", "page", "size", "total", "customer-tags", "downstream-allocations", "downstream-tag-preferences"])], 512), [[_vShow, activeTab.value === 'monthly-customers']]), _withDirectives(_createElementVNode("section", _hoisted_26, [_createVNode(InvoiceRegionListEditor, {
          plan: _unref(state).plan.value,
          regions: _unref(state).regions.value,
          customers: _unref(state).customers.value,
          "customers-by-region": _unref(state).customersByRegion.value,
          "downstream-allocations": _unref(state).downstreamAllocations.value,
          "downstream-tag-preferences": _unref(state).downstreamTagPreferences.value,
          syncing: _unref(state).syncing.value,
          onCreateRegion: openCreateRegion,
          onRenameRegion: openRenameRegion,
          onDeleteRegion: deleteRegion,
          onReorderRegions: reorderRegions,
          onSortRegionsByAmount: sortRegionsByAmount,
          onCreateCustomer: openCreateMonthFromRegion,
          onEditCustomer: openEditMonthFromPlanCustomer,
          onMoveCustomer: moveMatrixCustomer,
          onDeleteCustomer: deleteCustomer,
          onConfirmList: confirmList
        }, null, 8, ["plan", "regions", "customers", "customers-by-region", "downstream-allocations", "downstream-tag-preferences", "syncing"])], 512), [[_vShow, activeTab.value === 'list']]), _withDirectives(_createElementVNode("section", _hoisted_27, [_createVNode(InvoiceChainWorkspace, {
          plan: _unref(state).plan.value,
          chains: _unref(state).chains.value,
          customers: _unref(state).customers.value,
          regions: _unref(state).regions.value,
          "validation-issues": _unref(state).validationIssues.value,
          syncing: _unref(state).syncing.value,
          exporting: exportingChains.value,
          "focus-chain-id": companyRelationFocusChainId.value,
          "company-relation-keyword": companyRelationKeyword.value,
          "onUpdate:companyRelationKeyword": _cache[9] || (_cache[9] = $event => companyRelationKeyword.value = $event),
          "company-relation-result": companyRelationResult.value,
          "company-relation-loading": companyRelationLoading.value,
          onGenerate: generateChains,
          onExportChains: exportChains,
          onRegenerateUnlocked: regenerateUnlocked,
          onGenerateUnfilled: generateUnfilled,
          onEditNode: openEditNode,
          onLockChain: lockChain,
          onLockNode: lockNode,
          onRegenerateChain: regenerateChain,
          onRegenerateAfterNode: regenerateAfterNode,
          onSearchCompanyRelation: loadCompanyChainRelations,
          onClearCompanyRelation: clearCompanyChainRelations,
          onLocateCompanyRelation: locateCompanyRelation
        }, null, 8, ["plan", "chains", "customers", "regions", "validation-issues", "syncing", "exporting", "focus-chain-id", "company-relation-keyword", "company-relation-result", "company-relation-loading"])], 512), [[_vShow, activeTab.value === 'chains']])], 64))])]))])]), _createVNode(InvoicePlanModal, {
          modelValue: planModal.visible,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => planModal.visible = $event),
          mode: planModal.mode,
          "base-plan": planModal.basePlan,
          onSaved: afterPlanSaved
        }, null, 8, ["modelValue", "mode", "base-plan"]), _createVNode(InvoiceCustomerModal, {
          modelValue: customerModal.visible,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => customerModal.visible = $event),
          "plan-id": selectedPlanId.value,
          customer: customerModal.customer,
          regions: _unref(state).regions.value,
          "downstream-allocations": _unref(state).downstreamAllocations.value,
          "downstream-tag-preferences": _unref(state).downstreamTagPreferences.value,
          onSaved: handleCustomerModalSaved,
          onConfigureDownstream: openDownstreamAllocation,
          onConfigureTagPreference: openDownstreamTagPreference
        }, null, 8, ["modelValue", "plan-id", "customer", "regions", "downstream-allocations", "downstream-tag-preferences"]), _createVNode(InvoiceCustomerMasterModal, {
          modelValue: masterCustomerModal.visible,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => masterCustomerModal.visible = $event),
          mode: masterCustomerModal.mode,
          customer: masterCustomerModal.customer,
          "available-tags": customerTags.value,
          "selected-tag-ids": masterCustomerModal.tagIds,
          "tags-loading": masterCustomerModal.tagsLoading,
          regions: _unref(state).regions.value,
          customers: _unref(state).customers.value,
          "downstream-allocations": _unref(state).downstreamAllocations.value,
          "downstream-tag-preferences": _unref(state).downstreamTagPreferences.value,
          submitting: masterCustomerModal.saving,
          onSubmit: saveMasterCustomer
        }, null, 8, ["modelValue", "mode", "customer", "available-tags", "selected-tag-ids", "tags-loading", "regions", "customers", "downstream-allocations", "downstream-tag-preferences", "submitting"]), _createVNode(InvoiceRegionModal, {
          modelValue: regionModal.visible,
          "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => regionModal.visible = $event),
          region: regionModal.region,
          onSubmit: saveRegionModal
        }, null, 8, ["modelValue", "region"]), _createVNode(InvoiceNodeEditPanel, {
          modelValue: nodePanel.visible,
          "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => nodePanel.visible = $event),
          context: nodePanel.context,
          onSaved: saveNodeEdit
        }, null, 8, ["modelValue", "context"]), _createVNode(InvoiceDownstreamAllocationDialog, {
          modelValue: downstreamAllocationDialog.visible,
          "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => downstreamAllocationDialog.visible = $event),
          customer: downstreamAllocationDialog.customer,
          customers: _unref(state).customers.value,
          allocations: _unref(state).downstreamAllocations.value,
          submitting: _unref(state).syncing.value,
          onSubmit: saveDownstreamAllocations
        }, null, 8, ["modelValue", "customer", "customers", "allocations", "submitting"]), _createVNode(InvoiceDownstreamTagPreferenceDialog, {
          modelValue: downstreamTagPreferenceDialog.visible,
          "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => downstreamTagPreferenceDialog.visible = $event),
          customer: downstreamTagPreferenceDialog.customer,
          tags: customerTags.value,
          preferences: _unref(state).downstreamTagPreferences.value,
          submitting: _unref(state).syncing.value,
          onSubmit: saveDownstreamTagPreferences
        }, null, 8, ["modelValue", "customer", "tags", "preferences", "submitting"])]),
        _: 1
      });
    };
  }
};